import ComponentEx from 'components/ComponentEx';
import { getTxt } from 'global/appGlobal';
import { Dialog, DialogContent } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { EntityTypes, getEntityDescriptor } from 'global/entityDescriptors';
import { compose, graphql } from 'react-apollo';
import LinearProgressEx from '../../components/LinearProgressEx';
import c from '../../components/form/Components';
import MaterialForm from '../../components/form/MaterialForm';
import { DictionaryTypes, getDictionary, getLabel } from '../../global/dictionaryCache';
import { metadataQuery } from '../../home/Home';
import { authInfo, Roles } from '../../global/auth';
import GridEx from 'components/form/GridEx';

import * as queries from '../../modules/company/CompanyQueries';
import { Button } from '@material-ui/core';
import { QueuePlayNext } from '@material-ui/icons';


let history;
let AfterSubmit;
const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing.unit * 2,
        margin: theme.spacing.unit * 2,
    },
    formButtons: {
        float: 'right',
        margin: '15px',
    },
    button: {
        margin: theme.spacing.unit,
    },
});


class Company_Free_Item_Edit extends ComponentEx {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);

    }

    state = {
        open: false,
    };

    formSetValues = { func: undefined };



    onSubmit(e, { obj, showErrors, hideErrors }) {
        const original = this.props.data.companyFreeItemById;
        obj.company_free_item_id = original.company_free_item_id;

        this.props.update({
            variables: { companyFreeItem: obj },
            refetchQueries: [

                {
                    query: queries.allCompanyFreeItemsQuery,
                    variables: { id: this.props.id },
                },

            ],
        }, this).then(
            async (resp) => {
                hideErrors();
                if (resp.data.updateCompanyFreeItemMutation &&
                    resp.data.updateCompanyFreeItemMutation.validation &&
                    resp.data.updateCompanyFreeItemMutation.validation.length > 0) {
                    showErrors(resp.data.updateCompanyFreeItemMutation.validation);
                } else {
                    AfterSubmit(resp.data.updateCompanyFreeItemMutation.id);


                }
            });
    }

    render() {

        const { classes } = this.props;

        const loading = this.props.data.loading;
        const item = this.props.data.companyFreeItemById;
        history = this.props.history;
        AfterSubmit = this.props.AfterSubmit;

        const caption = (item && item.company_free_item_id !== '-1') ? getTxt('Modifica Movimento Libero') : getTxt('Nuovo Movimento Libero');

        let allowCompanySelect = false;
        if (authInfo.isAgencyAdministrator() || authInfo.isMasterBroker()) {
            allowCompanySelect = true;
        }
        if (this.props.companyId) {
            allowCompanySelect = false;
        }
        if (item && item.company_free_item_id !== '-1') {
            allowCompanySelect = false;
        }

        return (

            <Dialog onClose={() => { this.props.AfterSubmit(); }} open >
                <DialogContent>
                    <LinearProgressEx loading={loading} />


                    <Typography variant="h4" color="inherit" noWrap={false}>{caption}</Typography>

                    {item &&

                        <MaterialForm
                            dataSource={item}
                            objType={EntityTypes.CompanyFreeItem}
                            onSubmit={this.onSubmit}
                        >
                            {!this.props.companyId && <c.field f="insurance_company_id" d={!allowCompanySelect} ui="company_select" no_deleted />}
                            {this.props.companyId && <c.field f="insurance_company_id" d={!allowCompanySelect} ui="company_select" no_deleted v={this.props.companyId} />}


                            <c.field l={getTxt('Data')} f="payment_date" />
                            <c.field l={getTxt('Note')} f="payment_notes" />
                            <c.field f="payment_amount" />
                            <c.field f="provvigioni" />

                            <GridEx item sm={12} xs={12}>
                                <div className={classes.formButtons} >
                                    <Button
                                        className={classes.button}
                                        style={{ marginRight: 10 }}
                                        variant="contained"
                                        onClick={() => {
                                            this.props.AfterSubmit();
                                        }}
                                    >{getTxt('Annulla')}</Button>
                                    <Button
                                        color="primary"
                                        className={classes.button}
                                        type="submit"
                                        variant="contained"
                                    > {getTxt('Next')}</Button>
                                </div>

                            </GridEx>

                        </MaterialForm>

                    }

                </DialogContent>

            </Dialog>

        );
    }
}

export default compose(

    graphql(queries.companyFreeItemByIdQuery, {
        options: props => (
            {
                variables: {
                    id: props.id ? props.id : 'new',
                },
                fetchPolicy: 'network-only',
                errorPolicy: 'all',
            }
        ),
    }),

    graphql(queries.updateCompanyFreeItemMutation, {
        name: 'update',
        options: {
            errorPolicy: 'all',
            fetchPolicy: 'no-cache',
        },
    }),

)(withStyles(styles)(Company_Free_Item_Edit));
